import { render } from "./AlertModal.vue?vue&type=template&id=3dc9922e&bindings={\"title\":\"props\",\"content\":\"props\",\"continue_action\":\"props\",\"continue_btn\":\"props\",\"language\":\"setup\",\"lang\":\"data\",\"close\":\"options\",\"continueAction\":\"options\"}"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"

import "./AlertModal.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script